module.exports = __webpack_public_path__ + "img/landmark.aea6abb2.png";